// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QSJrC","left":"styles_left__3j18A","desktopActions":"styles_desktopActions__3ixSu","title":"styles_title__2Kh4O"};